import moment from 'moment';
import { ImageComponent } from 'presentation/components/ImageComponent';
import { TooltipText } from 'presentation/components/TooltipText';
import { COMMON } from 'utilities/constants/COMMON';
import { DATE_FORMAT } from 'utilities/constants/DATE';
import { DetailProperty } from '../models/DetailProperty';

interface props {
    data?: DetailProperty;
}

export const Detail = ({ data }: props) => {
    return !data ? (
        <></>
    ) : (
        <div style={{ display: 'inline-block' }}>
            <section className="image-container">
                <ImageComponent
                    width="455px"
                    alt=""
                    parentStyle={{justifyContent: 'left'}}
                    src={data.propertyImages.length > 0 ? data.propertyImages[0].fileUrl : Array}
                />
            </section>
            <section style={{ width: 343, marginTop: 24 }}>
                <div className="title-detail">
                    <TooltipText content={data?.propertyName ?? COMMON.EMPTY} />
                </div>
                <div style={{ marginTop: 12, display: 'flex', alignItems: 'center' }}>
                    <div style={{ width: '20%' }}>
                        <label className="label">住所</label>
                    </div>
                    <div style={{ width: '80%' }}>
                        <p className="content">{data.residence ?? COMMON.EMPTY}</p>
                    </div>
                </div>
                <div style={{ marginTop: 10, display: 'flex', alignItems: 'center' }}>
                    <div style={{ width: '20%' }}>
                        <label className="label">最寄駅</label>
                    </div>
                    <div style={{ width: '80%' }}>
                        <p className="content">{data.stationName ?? COMMON.EMPTY}</p>
                    </div>
                </div>
                <div style={{ marginTop: 10, display: 'flex', alignItems: 'center' }}>
                    <div style={{ width: '20%' }}>
                        <label className="label">築年月</label>
                    </div>
                    <div style={{ width: '80%' }}>
                        <p className="content">
                            {moment(data.builtAt, true).isValid()
                                ? moment(data.builtAt).format(DATE_FORMAT.FORMAT3)
                                : '-'}
                        </p>
                    </div>
                </div>
            </section>
        </div>
    );
};
